import React, {Component} from "react";
import {
    Table,
    Row,
    Col
}                         from "react-bootstrap";
import moment             from "moment";

import { IS_VALID } from "utils";

class View extends Component {
    render () {
        let {
            selectedData,
            evoucherSortColumnOptions,
            evoucherSortingOptions
        } = this.props;

        const GET_VALUE = (key, isShortName = false) => {
            if (IS_VALID(selectedData) && IS_VALID(selectedData.get(key))) {
              let value = "";
      
            if (
                key === "createdAt" ||
                key === "updatedAt" ||
                key === "earningPeriodStartDate" ||
                key === "earningPeriodEndDate"
              ) {
                value = moment(selectedData.get(key)).format("MMM-DD-YYYY");
              } else if (
                key === "tdd_campaignStartDate" ||
                key === "tdd_campaignEndDate" ||
                key === "tdd_earningPeriodStartDate" ||
                key === "tdd_earningPeriodEndDate"
              ) {
                value = moment(selectedData.get(key)).format("MMM-DD-YYYY hh:mm:ss A") + " TDD";
              } else if (
                key === "campaignStartDate" ||
                key === "campaignEndDate"
              ) {
                value = moment(selectedData.get(key)).format("MMM-DD-YYYY hh:mm:ss A");
              } else if (
                key === "createdBy" ||
                key === "updatedBy"
              ) {
                if (IS_VALID(selectedData.get(key))) {
                  value = selectedData.get(key).get("name") || "";
                }
              } else if (
                  key === "evoucherSorting"
              ) {
                  if (selectedData.get("evoucherSortColumn")) {
                    for (let item of evoucherSortColumnOptions) {
                        if (
                            selectedData.get("evoucherSortColumn") === item.value
                        ) {
                            value = item.label;
                            break;
                        }
                    }
                  }
                  
                  if (selectedData.get(key)) {
                    for (let item of evoucherSortingOptions) {
                        if (
                            selectedData.get(key) === item.value
                        ) {
                            value += " - " + item.label;
                            break;
                        }
                    }
                  }
              } else {
                value = selectedData.get(key);
              }
      
              return value;
            } else {
              return "";
            }
        };

          
        let data = [
            {
                label: "Image",
                value: GET_VALUE("image") !== "" ? (
                    <div
                        style={{
                        maxWidth: "200px",
                        maxHeight: "200px",
                        height: "200px",
                        width: "200px",
                        display: "table-cell",
                        verticalAlign: "middle"
                        }}
                    >
                        <img
                            src={GET_VALUE("image").url()}
                            width="100%"
                        />
                    </div>
                ) : (
                    ""
                )
            },
            {
                label: "Banner Image",
                value: GET_VALUE("bannerImage") !== "" ? (
                    <div
                        style={{
                        maxWidth: "300px",
                        maxHeight: "100px",
                        height: "100px",
                        width: "300px",
                        display: "table-cell",
                        verticalAlign: "middle"
                        }}
                    >
                        <img
                            src={GET_VALUE("bannerImage").url()}
                            width="100%"
                        />
                    </div>
                ) : (
                    ""
                )
            },
            {
                label: "Title",
                value: GET_VALUE("title")
            },
            {
                label: "Description",
                value: (
                  <p style={{ whiteSpace: "pre-wrap" }}>
                    {GET_VALUE("descriptions")}
                  </p>
                )
            },
            {
                label: "Earning Period",
                value: ""
            },
            {
                label: "Campaign Start Date",
                value: [
                  GET_VALUE("campaignStartDate"),
                  <br/>,
                  GET_VALUE("tdd_campaignStartDate")
                ]
            },
            {
                label: "Campaign End Date",
                value: [
                  GET_VALUE("campaignEndDate"),
                  <br/>,
                  GET_VALUE("tdd_campaignEndDate")
                ]
            },
            {
                label: "EVoucher Sorting",
                value: [
                  GET_VALUE("evoucherSorting")
                ]
            },
            {
                label: "Created At",
                value: GET_VALUE("createdAt")
            },
            {
                label: "Update At",
                value: GET_VALUE("updatedAt")
            },
            {
                label: "Created By",
                value: GET_VALUE("createdBy")
            },
            {
                label: "Update By",
                value: GET_VALUE("updatedBy")
            }
        ];

        let earningPeriod = GET_VALUE("earningPeriod");

        if (earningPeriod !== "") {
            data[4].value = earningPeriod.get("name");

            if (earningPeriod.get("shortName") === "DR") {
                data.splice(
                    5,
                    0,
                    {
                        label: "Earning Period Start Date",
                        value: [
                            GET_VALUE("earningPeriodStartDate"),
                            <br/>,
                            GET_VALUE("tdd_earningPeriodStartDate")
                        ]
                    },
                    {
                        label: "Earning Period End Date",
                        value: [
                            GET_VALUE("earningPeriodEndDate"),
                            <br/>,
                            GET_VALUE("tdd_earningPeriodEndDate")
                        ]
                    }
                );
            }

            if (earningPeriod.get("shortName") === "D") {
                let availabilityTimeConfig = GET_VALUE("availabilityTimeConfig");

                data.splice(
                    5,
                    0,
                    {
                        label: "Availability Start and End Time",
                        value: <Row>
                            <Col md={6}>
                            <p>
                                Start
                                <br/>
                                {availabilityTimeConfig && availabilityTimeConfig.start}
                            </p>
                            </Col>
                            <Col md={6}>
                            <p>
                                End
                                <br/>
                                {availabilityTimeConfig && availabilityTimeConfig.end}
                            </p>
                            </Col>
                        </Row>
                    }
                );
            }
        }

        return (
            <div>
                <Table
                    bordered
                    responsive
                    style={{
                        tableLayout: "fixed"
                    }}
                >
                    <tbody>
                    {data.map((item, index) => (
                        <tr key={index}>
                            <td>
                            <b>{item.label}</b>
                            </td>
                            <td>{item.value}</td>
                        </tr>
                    ))}
                    </tbody>
                </Table>
            </div>
        );
    }
}

import {connect}            from 'react-redux';
import {bindActionCreators} from 'redux';
import {generics}           from 'actions';
import {
  CAMPAIGN_CATEGORY
}                           from "actions/const";

function mapStateToProps(state) {
	let {
        CampaignCategory
	} = state;

    let {
        selectedData,
        evoucherSortColumnOptions,
        evoucherSortingOptions
    } = CampaignCategory;

	return {
        selectedData,
        evoucherSortColumnOptions,
        evoucherSortingOptions
	};
}

function mapDispatchToProps(dispatch) {
    const actions = {
        setValue: (state, action = CAMPAIGN_CATEGORY) => generics.setValue(action, state)
    };
  
    return {
        actions: bindActionCreators(actions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(View);


// WEBPACK FOOTER //
// ./components/CampaignCategory/FormContainer/View.js